import React from 'react'
import { css } from '@emotion/core'
import { ArrowCaret, ArrowSwap } from '@fs/zion-icon/dist/cjs/icons'

const sortableColumnHeaderBlock = css`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  font-weight: bold;
  padding: 4px;
  background-color: rgb(0, 0, 0, 0);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  transition:
    font-size 200ms,
    background-color 200ms;
  :hover {
    background-color: rgb(90, 90, 90, 0.1);
  }
  :active {
    background-color: rgb(125, 125, 125, 0.2);
    font-size: 0.9rem;
  }
`
const sortingOnColumnHeaderBlock = css`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  font-weight: bold;
  padding: 4px;
  background-color: rgb(90, 90, 90, 0.1);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  transition:
    font-size 200ms,
    background-color 200ms;
  :hover {
    background-color: rgb(90, 90, 90, 0.2);
  }
  :active {
    background-color: rgb(125, 125, 125, 0.3);
    font-size: 0.9rem;
  }
`
const sortableColumnHeaderInline = css`
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  padding: 4px;
  background-color: rgb(0, 0, 0, 0);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  transition:
    font-size 200ms,
    background-color 200ms;
  :hover {
    background-color: rgb(90, 90, 90, 0.1);
  }
  :active {
    background-color: rgb(125, 125, 125, 0.2);
    font-size: 0.9rem;
  }
`
const sortingOnColumnHeaderInline = css`
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  padding: 4px;
  background-color: rgb(90, 90, 90, 0.1);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  transition:
    font-size 200ms,
    background-color 200ms;
  :hover {
    background-color: rgb(90, 90, 90, 0.2);
  }
  :active {
    background-color: rgb(125, 125, 125, 0.3);
    font-size: 0.9rem;
  }
`

export default function SortableColumnHeader({ sortField, sortType, field, label, onClick, block }) {
  const getFieldSortingIcon = () => {
    if (field !== sortField) {
      return <ArrowSwap size="xs" direction="up" />
    }
    if (sortType === undefined) {
      return <ArrowSwap size="xs" direction="up" />
    }
    if (sortType === 'ascending') {
      return <ArrowCaret size="xs" direction="up" />
    }
    if (sortType === 'descending') {
      return <ArrowCaret size="xs" direction="down" />
    }
    return null
  }

  return (
    <>
      {block ? (
        <button
          css={sortField === field ? sortingOnColumnHeaderBlock : sortableColumnHeaderBlock}
          type="button"
          onClick={onClick}
        >
          <span style={{ flex: '1' }}>{label}</span>
          <span>{getFieldSortingIcon()}</span>
        </button>
      ) : (
        <button
          css={sortField === field ? sortingOnColumnHeaderInline : sortableColumnHeaderInline}
          type="button"
          onClick={onClick}
        >
          <span style={{ flex: '1' }}>{label}</span>
          <span>{getFieldSortingIcon()}</span>
        </button>
      )}
    </>
  )
}
